import React, { Component } from "react";
import { connect } from "react-redux";
import NumberFormat from "react-number-format";
import {
  getMemberInfo,
  selectMemberInfo,
  getDocumentFile,
  getDocumentLinks,
} from "../../../state/ducks/member/index";
import { alertActions } from "../../../state/ducks/alert/index";

class MemberInfo extends Component {
  componentDidMount() {
    this.props.getMemberInfo();
  }

  getDocumentFile = (documentId) => {
    if (documentId === null) {
      this.props.showError(
        "Sözleşmeniz henüz yüklenmemiştir. Müşteri temsilcinizle görüşebilirsiniz."
      );
    } else {
      this.props.getDocumentLink(documentId);
    }
  };

  render() {
    const { member } = this.props;
    var iconResmi = "";

    return (
      <div className="container-fluid">
        {/* yesil Alan*/}
        <div className="row" style={{ padding: "3%" }}>
          <div className="col-12">

            {/* KUTU 2  Haç */}
            {member.info &&
              member.info.map((item) => {
                let hac = item.orgTurId === 3;

                {
                  item.orgTurId === 2 ? (
                    iconResmi = "row no-gutters t-kutu t-yesilCizgi"

                  ) : hac ? (
                    iconResmi = "row no-gutters t-kutu t-turuncuCizgi"

                  ) : (
                    iconResmi = "row no-gutters t-kutu t-mavicizgi"

                  )
                }

                return (
                  <div className={iconResmi} key={item.id}>
                    <div
                      className="col bosluk backbottom"

                      style={
                        item.orgTurId === 2 ?
                          { backgroundImage: 'url("/assets/img/backgrounds/back_right_yesil.jpg")' } :
                          item.orgTurId === 3 ?
                            { backgroundImage: 'url("/assets/img/backgrounds/back_right_turuncu.jpg")' } :
                            item.orgTurId === 1 ?
                              { backgroundImage: 'url("/assets/img/backgrounds/back_right_mavi.jpg")' } :
                              {}}
                    >
                      {/* içerikler */}
                      {/* Başlık */}
                      <div className="row no-gutters align-items-center">
                        <div clss="col-auto">

                          {item.orgTurId === 2 ? (
                            <i className="t-icon-home1 icon" />
                          ) : hac ? (
                            <img
                              src="/assets/img/svg/icon_kabe.svg"
                              style={{ width: 70, height: "auto", paddingRight: 10 }}
                            />
                          ) : (
                            <i className="t-icon-truck1 icon" />
                          )}


                        </div>
                        <div className="col d-flex flex-column justify-content-center">
                          <div className="baslik px-0">Üyelik Bilgilerim</div>
                          <span className="altBaslik">
                            <span className="badge badge-warning"> {item.orgSis} </span>
                            &nbsp;<span className="badge badge-info">
                              <NumberFormat
                                decimalSeparator={false}
                                thousandSeparator={"."}
                                value={item.uyeNo}
                                displayType={"text"}
                              /></span>
                          </span>
                        </div>
                        <div
                          className="col-auto"
                          hidden={
                            item.statu === null ||
                            (item.statu !== 3 && item.statu !== 6)

                          }
                          style={{ padding: "5px" }}
                        >

                          <a
                            href="#indir"
                            className="t-icButonTrunucu"
                            onClick={() =>
                              this.getDocumentFile(item.dokumanId)
                            }
                          >
                            Sözleşme {" "}
                            <i className="t-icon-document-alt-stroke"></i>
                          </a>

                        </div>
                        <hr>
                        </hr>
                        <div className="col-auto">


                          {(item.kaynak === 2 && item.statu === 6) ||
                            item.kaynak !== 2 ? (
                            <a
                              href={`/Home/MemberDetail/${item.id}`}
                              className="t-icButonTrunucu"
                            >
                              Detaylar {" "}
                              <i className="t-icon-arrow-right2" />
                            </a>
                          ) : (
                            <a
                              href="#detay"
                              className="t-icButonTrunucu"
                              style={{
                                backgroundColor: "#7f8681",
                                color: "#fff",
                              }}
                            >
                              Detaylar {" "}
                              <i className="t-icon-arrow-right2" />
                            </a>
                          )}

                        </div>
                      </div>

                      {/* Çekiliş bilgileri */}
                      {(item.cekilisSiraNo !== null ?
                        <div><span className="badge badge-primary"  style={{ width: "100%", backgroundColor: "#979797" }}> Grup No : {item.cekilisGrupNo ?? " - "} &nbsp;&nbsp;&nbsp; Sıra No : {item.cekilisSiraNo ?? " - "} &nbsp;&nbsp;&nbsp; Çekiliş Tarihi : {item.cekilisTarih ?? " - "}</span></div>
                        : <span></span>
                      )}
                      {/* Çekiliş bilgileri */}

                      <div className="col-12 t-hrUzun">
                        <hr />
                      </div>
                      {/* Satır */}
                      <div className="row no-gutters">
                        <div className="col-12 satirOzellikleri">
                          <span className="maviBaslik" style={item.kayitTuruId === 8 ? { color: "red" } : {}}>Kayıt Türü</span>
                          <span style={item.kayitTuruId === 8 ? { color: "red" } : {}} >{item.kayitTuru}</span>
                        </div>
                        <div className="col-12 t-hr">
                          <hr />
                        </div>
                      </div>
                      {/* Satır */}
                      <div className="row no-gutters">
                        <div className="col-12 satirOzellikleri">
                          <span className="maviBaslik">Organizasyon Tutarı</span>
                          <span>
                            <NumberFormat
                              decimalSeparator={","}
                              thousandSeparator={"."}
                              suffix={hac ? " XAU" : " ₺"}
                              value={item.orgTutar}
                              displayType={"text"}
                            /></span>
                        </div>
                        <div className="col-12 t-hr">
                          <hr />
                        </div>
                      </div>
                      {/* Satır */}
                      <div className="row no-gutters">
                        <div className="col-12 satirOzellikleri">
                          <span className="maviBaslik">Taksit Sayısı</span>
                          <span>{item.taksitSayisi}</span>
                        </div>
                        <div className="col-12 t-hr">
                          <hr />
                        </div>
                      </div>
                      {/* Satır */}
                      <div className="row no-gutters" hidden={item.grupNo === null}>
                        <div className="col-12 satirOzellikleri">
                          <span className="maviBaslik">Grup No</span>
                          <span>{item.grupNo}</span>
                        </div>
                        <div className="col-12 t-hr">
                          <hr />
                        </div>
                      </div>
                      {/* Satır */}
                      <div className="row no-gutters">
                        <div className="col-12 satirOzellikleri">
                          <span className="maviBaslik">Başlangıç Tarihi</span>
                          <span>{item.baslangicTarihi}</span>
                        </div>
                        <div className="col-12 t-hr">
                          <hr />
                        </div>
                      </div>
                      {/* Satır */}
                      <div className="row no-gutters" hidden={item.kayitTuruId !== 8 || item.ayrilmaTarihi === null || item.ayrilmaTarihi === ""}>
                        <div className="col-12 satirOzellikleri">
                          <span className="maviBaslik">Ayrılma Tarihi</span>
                          <span>{item.ayrilmaTarihi}</span>
                        </div>
                        <div className="col-12 t-hr">
                          <hr />
                        </div>
                      </div>
                      {/* Satır */}
                      <div className="row no-gutters " hidden={item.kayitTuruId === 8}>
                        <div className="col-12 satirOzellikleri">
                          <span className="maviBaslik">
                            {item.kayitTuruId !== 10 &&
                              item.kayitTuruId !== 11
                              ? "Planlanan "
                              : ""}Teslim Tarihi</span>
                          <span>{item.teslimTarihi}</span>
                        </div>
                        <div className="col-12 t-hr">
                          <hr />
                        </div>
                      </div>
                      {/* Satır */}
                      <div className="row no-gutters"
                        hidden={
                          item.kayitTuruId === 8 ||
                          item.dondurulanAy === "0" ||
                          item.dondurulanAy === null ||
                          item.dondurulanAy === 0
                        }>
                        <div className="col-12 satirOzellikleri">
                          <span className="maviBaslik">  Taksit Erteleme</span>
                          <span>{item.dondurulanAy} Ay</span>
                        </div>
                        <div className="col-12 t-hr">
                          <hr />
                        </div>
                      </div>
                      {/* Satır */}
                      {item.kaynak === 2 && (
                        <>
                          <div className="row no-gutters">
                            <div className="col-12 satirOzellikleri">
                              <span className="maviBaslik">Kaynak</span>
                              <span>E-Sözleşme</span>
                            </div>
                            <div className="col-12 t-hr">
                              <hr />
                            </div>
                          </div>

                          <div className="row no-gutters">
                            <div className="col-12 satirOzellikleri">
                              <span className="maviBaslik">Durumu</span>
                              <span>{item.statuDisplay}</span>
                            </div>
                            <div className="col-12 t-hr">
                              <hr />
                            </div>
                          </div>
                        </>
                      )}
                      <div className="row no-gutters align-items-center" style={{ fontSize: "11pt", color: "red", fontStyle: "italic" }} hidden={item.kayitTuruId !== 12}>
                        <span>Ayrılma süreciniz sonlanana kadar üyeliğinize devam etme hakkınız bulunmaktadır. Devam etme düşünceniz yok ise ödeme yükümlülüğünüz bulunmamaktadır.</span>
                      </div>
                      {/* içerikler BİTTİ */}
                    </div>
                    <div className="col-auto renk" />
                  </div>
                );
              })}

          </div>
        </div>
        {/* Duyurlar Baslık*/}
        {/* duyrular Bitti*/}
        <div className="row" style={{ height: 30 }} />
      </div >

    )
  }
}

const mapStateToProps = (state) => {
  return {
    member: selectMemberInfo(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  getMemberInfo: () => dispatch(getMemberInfo()),
  getDocumentFile: (documentId) => dispatch(getDocumentFile(documentId)),
  getDocumentLink: (documentId) => dispatch(getDocumentLinks(documentId)),
  showError: (message) => dispatch(alertActions.showError(message)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MemberInfo);
